module.exports = __webpack_public_path__ + "static/logo-82df75fc64d5beeed43573f1c89f3263.png";